export default __webpack_public_path__ + "static/media/typeScript.9c26f8b2.png";